import {
  ChangeDetectorRef, Component, EventEmitter,
  Input, Output, OnChanges, SimpleChanges,
} from '@angular/core';
import * as _ from 'lodash';
import { FormArray, UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';

import { Option } from 'shared/option/option.model';
import { usStateLookup } from 'utils/lookups';

import { ActiveFilterModel } from '../active-filters/active-filter.model';
import { SIMPLE_FILTER_TYPE } from '../active-filters/active-filter-types';



@Component({
  moduleId: module.id,
  selector: 'state-search',
  templateUrl: 'state-search.component.html',
  styleUrls: ['state-search.component.scss'],
})
export class StateSearchComponent implements OnChanges {
  stateOptions: Array<Option> = usStateLookup;
  isActive: boolean = true;
  formGroup: UntypedFormGroup;

  @Input() ghostValue: string;
  @Input() filters: Array<ActiveFilterModel> = []; // all active filters

  @Output() selectChange: EventEmitter<any> = new EventEmitter();

  constructor(
    private ref: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
  ) {
    this.formGroup = this.fb.group({
      state: this.fb.control('')
    });
  }

  /*******************************************
  * COMPONENT GETTERS
  *******************************************/

  get selectedFilters(): Array<any> {
    return this.getFilters();
  }

  /*******************************************
  * COMPONENT HOOKS
  *******************************************/

  ngOnChanges(changes: SimpleChanges) {
    if (changes.filters && changes.filters.currentValue) {
      this.updateSelectedFilters();
    }
  }

  /*******************************************
  * COMPONENT PUBLIC METHODS
  *******************************************/

  public clearFilter(filter: ActiveFilterModel) {
    if (filter._id === 'state') {
      this.formGroup.get('state').patchValue('');
    }
  }

  public clearAllFilters() {
    this.formGroup.get('state').patchValue('');
  }

  /*******************************************
  * COMPONENT PRIVATE METHODS
  *******************************************/

  private getFilters(): ActiveFilterModel[] {
    // right now it's only state filter
    // zip & miles - soon
    const selectedState = this.formGroup.get('state').value;
    if (!selectedState) { return null; }
    return [new ActiveFilterModel(
      'state',
      `${_.get(_.find(this.stateOptions, {option: selectedState}), 'title')}`,
      SIMPLE_FILTER_TYPE,
      selectedState,
    )];
  }

  private updateSelectedFilters() {
    const stateFilter = _.find(this.filters, {_id: 'state'});
    if (stateFilter) {
      // @ts-ignore
        this.formGroup.get('state').patchValue(stateFilter.data);
    }
  }
}
